function RedesSociais() {
  return (
    <div className="RedesSociais">
      <footer className="RedesSociais-footer">
        <h3>Redes Sociais</h3>
        <ul className="mapaFooter">
          <li>Instagram</li>
          <li>Facebook</li>
          <li>Threads</li>
        </ul>
      </footer>
    </div>
  );
}

export default RedesSociais;
